import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, X } from "lucide-react";
import { onboardingSteps, readDismissed, shouldShowOnboarding, writeDismissed } from "@/lib/onboarding";

export default function OnboardingChecklist({ balance, videos, counts, ready, storage = typeof window !== "undefined" ? window.localStorage : null }) {
  const [dismissed, setDismissed] = useState(() => (storage ? readDismissed(storage) : false));
  const steps = onboardingSteps({ balance, videos, counts });
  if (!shouldShowOnboarding(steps, dismissed, ready)) return null;
  const done = steps.filter((s) => s.done).length;
  return (
    <section className="rounded-2xl border border-blue-100 bg-blue-50 p-5" data-testid="onboarding" aria-label="Mulai di sini">
      <div className="flex items-start justify-between gap-3">
        <div><h2 className="font-heading text-lg font-semibold text-slate-900">Mulai di sini</h2><p className="text-sm text-slate-600" data-testid="onboarding-progress">{done} dari {steps.length} langkah selesai</p></div>
        <button type="button" aria-label="Sembunyikan panduan" className="rounded p-1 text-slate-500 hover:bg-blue-100" data-testid="onboarding-dismiss"
                onClick={() => { if (storage) writeDismissed(storage); setDismissed(true); }}><X className="h-4 w-4" /></button>
      </div>
      <ul className="mt-3 space-y-2">
        {steps.map((s) => (
          <li key={s.id} className="flex items-start gap-2 text-sm" data-testid={`onboarding-step-${s.id}`} data-done={s.done ? "true" : "false"}>
            {s.done ? <CheckCircle2 className="mt-0.5 h-4 w-4 text-emerald-600" /> : <Circle className="mt-0.5 h-4 w-4 text-slate-400" />}
            <span><Link to={s.to} className="font-medium text-blue-700 hover:underline">{s.label}</Link><span className="block text-xs text-slate-500">{s.hint}</span></span>
          </li>
        ))}
      </ul>
    </section>
  );
}
